/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

export const template23 = {
  title: t.to('ワープボタン', 'title23'),
  desc: t.to(
    `全天球の背景をワープボタンで切り替えることができるJavaScriptのプログラムです`,
    'desc23'
  ),
  img: '../public/template/23.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" id="#Ldj|tEFv__sH@U:?J)=" x="170" y="70">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="a-sky" id="|M]LOvq;{uHrL_hj-pby">
        <value name="COLOUR">
          <shadow type="color_value_v2" id="X^mW!_tV;E.\`TfR^U%__">
            <field name="COLOUR">#FFFFFF</field>
          </shadow>
        </value>
        <value name="ATTR">
          <block type="src_att_v2" id="/SS#D:as#/,2N{+IgbxC">
            <field name="image_src">https://live.staticflickr.com/65535/52050893807_95be900320_h.jpg</field>
            <field name="src_att_v2">
            </field>
            <value name="ATTR">
              <block type="a-opacity" id="~8$zDEtHPPoh]I(,)!uM">
                <field name="opacity">1</field>
                <value name="ATTR">
                  <block type="id_v2" id="Z9BG;L0Gb58~D?4~,?Z;">
                    <field name="id">1</field>
                  </block>
                </value>
              </block>
            </value>
          </block>
        </value>
        <next>
          <block type="a-sky" id="oTxGx3tQ^_M)MyGYb3Mj">
            <value name="COLOUR">
              <shadow type="color_value_v2" id="C^F;lK%jnFN?4%2|/Bt@">
                <field name="COLOUR">#FFFFFF</field>
              </shadow>
            </value>
            <value name="ATTR">
              <block type="src_att_v2" id="S[^D2m*}U)M@NRbSXKB!">
                <field name="image_src">https://live.staticflickr.com/65535/52773879375_024fe4b779_h.jpg</field>
                <field name="src_att_v2">
                </field>
                <value name="ATTR">
                  <block type="a-opacity" id="3~2lg$|=is~-8/271@7}">
                    <field name="opacity">0</field>
                    <value name="ATTR">
                      <block type="id_v2" id="s^|IwR8~p*4zVr.jm*%%">
                        <field name="id">2</field>
                      </block>
                    </value>
                  </block>
                </value>
              </block>
            </value>
            <next>
              <block type="a-sky" id="#I}0rvoUnsbGNg3Pag:0">
                <value name="COLOUR">
                  <shadow type="color_value_v2" id="NjXvLG|-/PwU!JDzk$VU">
                    <field name="COLOUR">#FFFFFF</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="src_att_v2" id="-wor6?h\`TP@h~dXX-,RZ">
                    <field name="image_src">https://live.staticflickr.com/2249/2264878494_5189810acc_h.jpg</field>
                    <field name="src_att_v2">
                    </field>
                    <value name="ATTR">
                      <block type="a-opacity" id="Nc6.,/Ti5\`bqTXd;L1C;">
                        <field name="opacity">0</field>
                        <value name="ATTR">
                          <block type="id_v2" id="4bMI+y]K5c_l/#~pYQpr">
                            <field name="id">3</field>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </value>
                <next>
                  <block type="gltf_element_v2" id="S3qBHo@{-NlC!ajH*N^r">
                    <field name="nameField">big_red_button.glb</field>
                    <field name="src">/public/preset/3DModel/big_red_button/big_red_button.glb</field>
                    <field name="position-x">0</field>
                    <field name="position-y">1</field>
                    <field name="position-z">0</field>
                    <value name="ATTR">
                      <block type="a-static-body_v2" id="SQB#%AZg$W21rLnWBu..">
                        <value name="ATTR">
                          <block type="onclick_att" id="XdMkE*t8e6CDdCxPS12!">
                            <field name="func">change_photo</field>
                            <value name="ATTR">
                              <block type="rotation_v2" id="M[:|J6PrW+b8P|Y_R=2-">
                                <field name="rotation-x">90</field>
                                <field name="rotation-y">360</field>
                                <field name="rotation-z">360</field>
                              </block>
                            </value>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </next>
              </block>
            </next>
          </block>
        </next>
      </block>
    </statement>
  </block>
  <block type="logic_function_v2" id="@J+%C;f][y-7p|:km{Xi" x="170" y="450">
    <field name="FUNCTION_NAME">change_photo</field>
    <field name="arg">
    </field>
    <statement name="IN">
      <block type="logic_ifelse_v2" id="^#.ZjlLZ!027K{CNRS[.">
        <value name="DECISION">
          <block type="logic_less_than_v2" id=".pN~^1L1DmxcOJH]tk7I">
            <field name="LEFT">=current_id</field>
            <field name="RIGHT">=ids.length</field>
          </block>
        </value>
        <statement name="TRUE_PART">
          <block type="logic_set_value_v2" id=",{z*NevqT@(119b@eP!_">
            <field name="VAR_NAME">current_id</field>
            <field name="VALUE">=current_id+1</field>
          </block>
        </statement>
        <statement name="FALSE_PART">
          <block type="logic_set_value_v2" id="={Xd|T)Y[th5S6-P3w0h">
            <field name="VAR_NAME">current_id</field>
            <field name="VALUE">1</field>
          </block>
        </statement>
        <next>
          <block type="logic_function_call_v" id="RiXXmb~(Q0snKw$%2qc.">
            <field name="FUNCTION_NAME">toggle</field>
            <field name="arg">
            </field>
          </block>
        </next>
      </block>
    </statement>
  </block>
  <block type="logic_init_process" id="oNZaIy}Xkeh5|:~If[;n" x="790" y="470">
    <statement name="IN">
      <block type="logic_set_value_v2" id="61UpF,gN~WqQf;a0Tbhp">
        <field name="VAR_NAME">current_id</field>
        <field name="VALUE">1</field>
        <next>
          <block type="logic_set_array_v2" id="F,R7vQo1@bVaK:41VVDI">
            <field name="VAR_NAME">ids</field>
            <field name="VALUE"> 1, 2, 3</field>
          </block>
        </next>
      </block>
    </statement>
  </block>
  <block type="logic_function_v2" id="v*=*Ii?y;Xmkr$f\`d}rx" x="170" y="830">
    <field name="FUNCTION_NAME">toggle</field>
    <field name="arg">
    </field>
    <statement name="IN">
      <block type="logic_list-loop_v2" id="Lk#lglq#Qv6GDvjLnbzn">
        <field name="COUNTER_VAR">id</field>
        <field name="ARRAY_NAME">ids</field>
        <statement name="IN">
          <block type="logic_ifelse_v2" id="R6@hjJF9B*Vu\`5O/M5?">
            <value name="DECISION">
              <block type="logic_equal_v2" id="wC*sb\`C5PiBCZQg!?rHR">
                <field name="LEFT">=id</field>
                <field name="RIGHT">=current_id</field>
              </block>
            </value>
            <statement name="TRUE_PART">
              <block type="logic_update_attribute" id="42HxOdn*+DWEJ3l|:R~4">
                <field name="VAR_NAME">=id</field>
                <value name="ATTR">
                  <block type="a-opacity" id="YsKl\`zB56BmX{3aZwFJY">
                    <field name="opacity">1</field>
                  </block>
                </value>
              </block>
            </statement>
            <statement name="FALSE_PART">
              <block type="logic_update_attribute" id="1Wiw)LyVFY!%]4b,[n72">
                <field name="VAR_NAME">=id</field>
                <value name="ATTR">
                  <block type="a-opacity" id="Spw@v7x:xB!kqvakONFU">
                    <field name="opacity">0</field>
                  </block>
                </value>
              </block>
            </statement>
          </block>
        </statement>
      </block>
    </statement>
  </block>
</xml>
`,
  js_code: ``,
};
